import React, { memo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCustomerProfile } from 'src/selectors/customer'
import { useNavigate } from 'react-router-dom'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { CustomerBankPaymentForm } from 'src/components/customer/customer-payment-method-form/BankPaymentForm'
import { CustomerUploadBankInformation } from 'src/constants/actionTypes'
import { BankInformationRequest } from 'src/components/customer/customer-payment-method-form/BankPaymentForm.interface'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { showToast } from 'src/utils/toast'

const CustomerResubmitPaymentMethodPageComponent = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const customerProfile = useSelector(getCustomerProfile)

  const handleBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  const handleSubmitBankInformation = useCallback(
    async (requestBody: BankInformationRequest) => {
      try {
        await createAsyncAction(dispatch, CustomerUploadBankInformation.request(requestBody))

        navigate(-1)
      } catch (error: any) {
        const errorMessage =
          typeof error?.payload?.message === 'string'
            ? error?.payload?.message
            : 'Something went wrong'

        showToast(errorMessage, { variant: 'error' })
      }
    },
    [navigate, dispatch],
  )

  if (!customerProfile) {
    return <FullScreenLoader />
  }

  return (
    <div data-testid="customer-account-resubmit-payment-method-page">
      <CustomerBankPaymentForm
        showCurrentPaymentMethod={!!customerProfile?.paymentMethod?.isCompleted}
        onSubmitBankInformation={handleSubmitBankInformation}
      />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          data-testid="customer-account-resubmit-back-btn"
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </div>
  )
}

export const CustomerResubmitPaymentMethodPage = memo(CustomerResubmitPaymentMethodPageComponent)
